export const REWARD_LIST = "REWARD_LIST";
export const REWARD_LIST_MEMBER_GROUP_ITEM = "REWARD_LIST_MEMBER_GROUP_ITEM";
export const FAVORITE_LIST = "FAVORITE_LIST";
export const FAVORITE = "FAVORITE";
export const CART_LIST = "CART_LIST";
export const CART_ADD = "CART_ADD";
export const CART_UPDATE = "CART_UPDATE";
export const CHECKOUT = "CHECKOUT";
